import { Card, Switch, ToastTypeEnum, showToast } from '@wonderschool/common-base-ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { updateOrganization } from '../../../api/firebase/organizations';
import { useOrganization } from '../../../hooks/useOrganizations';
import { logError } from '../../../rollbar';

const PaymentDigestSettings = () => {
  const { t } = useTranslation();
  const organization = useOrganization();
  const savedEnabled = organization?.isPaymentDigestEnabled !== false;
  const [isEnabled, setIsEnabled] = useState(savedEnabled);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setIsEnabled(savedEnabled);
  }, [organization?.id, savedEnabled]);

  const handleChange = async (enabled: boolean) => {
    if (!organization?.id || isSaving) return;

    setIsEnabled(enabled);
    setIsSaving(true);
    try {
      await updateOrganization(organization.id, { isPaymentDigestEnabled: enabled });
      showToast(ToastTypeEnum.Success, t('paymentDigestSettingsSaved'));
    } catch (error) {
      setIsEnabled(savedEnabled);
      logError('Error updating payment digest settings', error, { organizationId: organization.id });
      showToast(ToastTypeEnum.Error, t('paymentDigestSettingsSaveError'));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Card>
      <div className="space-y-4 p-4">
        <h2 className="text-xl font-semibold">{t('billing.paymentDigestSettings.title')}</h2>
        <Switch
          id="payment-digest-enabled"
          valueLabel={t('paymentDigestSettingsLabel')}
          checked={isEnabled}
          disabled={isSaving || !organization?.id}
          onChange={(event) => handleChange(event.target.checked)}
        />
        <p className="text-gray-700">{t('paymentDigestSettingsDescription')}</p>
      </div>
    </Card>
  );
};

export default PaymentDigestSettings;
